import $ from 'jquery';
import './contentSlider';


$(document).ready(function () {

  $(".filter-style-js, .filter-orientation-js, .filter-type-js").change(function () {
    handleFilters();
  })

  function handleFilters() {
    let orientation = "";
    let orientationHorizontalSelector = $(".filter-orientation-horizontal");
    let orientationVerticalSelector = $(".filter-orientation-vertical");

    if (orientationHorizontalSelector.is(":checked") == orientationVerticalSelector.is(":checked")) {
      // show all
    }
    else if (orientationHorizontalSelector.is(":checked")) {
      orientation = "horizontal";
    }
    else if (orientationVerticalSelector.is(":checked")) {
      orientation = "vertical";
    }


    let calendar_type = "";
    let calendarTypeNormalSelector = $(".filter-type-normal");
    let calendarTypeKlappSelector = $(".filter-type-klapp");

    if (calendarTypeNormalSelector.is(":checked") == calendarTypeKlappSelector.is(":checked")) {
      // show all
    }
    else if (calendarTypeNormalSelector.is(":checked")) {
      calendar_type = "normal";
    }
    else if (calendarTypeKlappSelector.is(":checked")) {
      calendar_type = "klapp";
    }

    $(".calendar-row").each(function () {

      let orientationFound = false;
      let typeFound = false;

      if (
        (orientation != "" && $(this).data('orientation') == orientation) || orientation == ""
      ) {
        orientationFound = true;
      }

      if (
        (calendar_type != "" && $(this).data('type') == calendar_type) || calendar_type == ""
      ) {
        typeFound = true;
      }

      if (orientationFound && typeFound)
        $(this).show();
      else
        $(this).hide();
    })

  }

});
